import {
  GET_BROWSER_LOCATION_START,
  SET_BROWSER_LOCATION,
  SET_GEOLOCATION_STATUS,
} from './types';

export const getBrowserLocation = () => ({
  type: GET_BROWSER_LOCATION_START,
});

export const setBrowserLocation = payload => ({
  type: SET_BROWSER_LOCATION,
  payload,
});

export const setGeolocationStatus = payload => ({
  type: SET_GEOLOCATION_STATUS,
  payload,
});
